export const testDev = (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')
console.log("ENVIRONMENT: " + process.env.NODE_ENV );
if (testDev) console.warn('Env: ' + process.env.NODE_ENV + " " + testDev);

export const SERVER_BASE_URL = "/api/";
 //export const SERVER_BASE_URL = "https://localhost:7297/"
console.log("ENVIRONMENT: " + SERVER_BASE_URL );
